<div class="commission-container">
  <!-- Header -->
  <div class="header">
    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <!-- Go Back Action -->
      <button class="action-btn secondary-btn icon-btn" (click)="goBack()">
        <span class="icon">
          <img src="assets/icones/close_icon.svg" alt="" />
        </span>
      </button>
      <span>
        <div class="breadcrumb-item">{{ 'commission.title' | translate }}</div>
      </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span class="truncate" style="max-width: 400px; font-weight: 600" [title]="commission?.name"> {{ commission?.name }} </span>
      <span class="tag" [class.positive]="commission?.status === 'active'" [class.negative]="commission?.status === 'disabled'">{{
        "commission.status." + commission?.status | translate
      }}</span>
    </div>
    <!-- Catalog Actions -->
    <div style="display: flex; gap: 20px; align-items: center">
      <button [matMenuTriggerFor]="menu" class="action-btn secondary-btn icon-btn more-btn">
        <span class="icon"><mat-icon>more_vert</mat-icon></span>
      </button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
        <button mat-menu-item class="delete-btn" (click)="confirmationDialog('delete')">
          <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
          {{ 'common.delete' | translate }}
        </button>
      </mat-menu>
      <button
        class="action-btn secondary-btn"
        [class.disable-btn]="commission?.status === 'active'"
        [class.enable-btn]="commission?.status === 'disabled'"
        (click)="confirmationDialog(commission?.status === 'active' ? 'disable' : 'enable')"
      >
        <span class="icon" *ngIf="commission?.status === 'active'">
          <app-svg-icon svgIcon="stop-cc"></app-svg-icon>
        </span>
        <span>{{ (commission?.status === "active" ? "commission.actions.disable" : "commission.actions.enable") | translate }}</span>
      </button>
      <button class="action-btn primary-btn" (click)="confirmationDialog('edit')">
        <span class="icon">
          <app-svg-icon svgIcon="refresh-cc"></app-svg-icon>
        </span>
        <span>{{ 'common.update' | translate }}</span>
      </button>
    </div>
  </div>
  <!-- Content -->
  <div class="commission-content">
    <!-- Left Panel -->
    <div class="left-panel">
      <div class="header">{{ 'commission.tabs.settings' | translate }}</div>
      <div class="content" *ngIf="commission">
        <app-commission-settings [commission]="commission" #commissionSettings></app-commission-settings>
      </div>
    </div>
    <div class="right-panel">
      <div class="tabs">
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'agents'"
          [class.active]="rightPanelActiveTab === 'agents'"
          (click)="rightPanelActiveTab = 'agents'"
        >
          {{ 'commission.tabs.assigned_agents' | translate }}
        </div>
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'thresholds'"
          [class.active]="rightPanelActiveTab === 'thresholds'"
          (click)="rightPanelActiveTab = 'thresholds'"
        >
          {{ 'commission.tabs.volume_thresholds' | translate }}
          <span *ngIf="!thresholdsTabValid" class="invalid-step">
            <app-svg-icon svgIcon="info-cc"></app-svg-icon>
          </span>
        </div>
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'negotiation'"
          [class.active]="rightPanelActiveTab === 'negotiation'"
          (click)="rightPanelActiveTab = 'negotiation'"
        >
          {{ 'commission.tabs.negotiation_rules' | translate }}
          <span *ngIf="!negotiationTabValid" class="invalid-step">
            <app-svg-icon svgIcon="info-cc"></app-svg-icon>
          </span>
        </div>
      </div>
      <div class="tab-content-wrapper" *ngIf="commission">
        <app-commission-agents
          [commission]="commission"
          [ngClass]="{ 'hidden-tab': rightPanelActiveTab !== 'agents' }"
          #commissionAgents
        ></app-commission-agents>
        <app-commission-thresholds
          [commission]="commission"
          [ngClass]="{ 'hidden-tab': rightPanelActiveTab !== 'thresholds' }"
          #commissionThresholds
        ></app-commission-thresholds>
        <app-commission-negotiation
          [commission]="commission"
          [ngClass]="{ 'hidden-tab': rightPanelActiveTab !== 'negotiation' }"
          #commissionNegotiation
        ></app-commission-negotiation>
      </div>
    </div>
  </div>
</div>
